import React, { memo } from 'react';

const ErrorPage: React.FC = () => {
  return (
    <div>
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
    </div>
  )
}

export default memo(ErrorPage);
